import { isPresent } from 'utils/isPresent';
import { combineReducers } from 'redux'
import { ENTITIES_NAMESPACE, DATA_FETCHED } from "./DataConstants"

export class ReducerRegistry {
    constructor() {
        this._emitChange = null;
        this._reducers = {};
        this._entityReducers = {};
    }

    getReducers() {
        return { ...this._reducers };
    }

    register(name, reducer) {
        this._reducers = { ...this._reducers, [name]: reducer };
        if (this._emitChange) {
            this._emitChange(this.getReducers());
        }
    }

    registerEntityReducer(name, reducer) {
      this._entityReducers = { ...this._entityReducers, [name]: reducer };
      const combinedEntityReducers = combineReducers({...this._entityReducers})

      this.register(ENTITIES_NAMESPACE, combinedEntityReducers)
    }

    isReducerPresent(name) {
        return isPresent(this._reducers[name])
    }

    isEntityReducerPresent(name) {
      return isPresent(this._entityReducers[name])
    }

    setChangeListener(listener) {
        this._emitChange = listener;
    }

    reset() {
        this._emitChange = null
        this._reducers = {}
        this._entityReducers = {}
    }
}

const reducerRegistry = new ReducerRegistry();
export default reducerRegistry;
